/**
 * IOT-MULTI-LEG-CONTINUITY-1 — VizionAisAdapter (VENDOR-REGISTRY-DOCTRINE-1)
 *
 * TYPE_ONLY registry stub for the Vizion AIS ocean vessel tracking provider.
 * Operational integration is handled by AisMarineFeedAdapter.js and the
 * dynamic adapters in src/services/iot/multi-leg/adapters/.
 *
 * This stub satisfies the VENDOR-REGISTRY-DOCTRINE-1 adapter-module contract
 * (category: container, tier: third-party-tier-1). No DeviceContract
 * implementation — Vizion is a web-API data provider, not an IoT device vendor.
 *
 * Credentials are tenant-provisioned; no API keys in source code.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

export class VizionAisAdapter extends NotImplementedAdapter {
  static VENDOR_ID = 'vizion_ais';
  static CAPABILITIES = Object.freeze({
    telemetry: false,
    config: false,
    health: false,
    events: false,
  });

  constructor(device) {
    super(device, VizionAisAdapter.VENDOR_ID, VizionAisAdapter.CAPABILITIES);
  }
}

/**
 * Curried factory matching the VENDOR-REGISTRY-DOCTRINE-1 convention used by
 * all other adapters: called with no boot-time args, returns a (device) => instance
 * factory that HalService invokes lazily on first getAdapter(deviceId).
 *
 * @returns {(device: object) => VizionAisAdapter}
 */
export function createVizionAisAdapterFactory() {
  return (device) => new VizionAisAdapter(device);
}

export default { VizionAisAdapter, createVizionAisAdapterFactory };
